const TogglePill = ({ textValue, id, checked, onChange, name }) => (
  <label className="swpmdl-checkbox" htmlFor={id}>
    <input
      type="checkbox"
      className="swp-toggle-checkbox"
      checked={checked}
      id={id}
      data-id={id}
      onChange={onChange}
      name={name}
    />
    <div className="swp-toggle">
      <div className="swp-toggle-pill"></div>
    </div>
    <span className="checkbox-text">{textValue}</span>
  </label>
)

export default TogglePill
